import { useMemo, useState } from "react";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, Legend } from "recharts";
import { SectionCard } from "./shared";

const MODES = [
    { v: "first_seen", l: "First seen (historical)" },
    { v: "live_added", l: "Live captures" },
    { v: "prevented", l: "Prevented sends" },
];

export function SuppressionActivity({ data }) {
    const [mode, setMode] = useState("first_seen");
    const rows = useMemo(() => (data.days || []).map((d) => ({
        date: d.date.slice(5),
        dnc: (mode === "live_added" ? d.live_added : d.first_seen).marketing_dnc,
        technical: (mode === "live_added" ? d.live_added : d.first_seen).technical,
        review: (mode === "live_added" ? d.live_added : d.first_seen).manual_review,
        prevented: d.prevented_sends,
    })), [data, mode]);
    return (
        <SectionCard testId="suppression-activity" title="Suppression activity"
                     sub="First seen = when the earliest evidence happened, not when the record was created by the backfill.">
            <div className="flex gap-2 mb-4" data-testid="activity-mode-toggle">
                {MODES.map((m) => (
                    <button key={m.v} type="button" onClick={() => setMode(m.v)} data-testid={`activity-mode-${m.v}`}
                            className={`rounded-full border px-3 py-1 text-xs transition-colors ${mode === m.v ? "bg-gray-900 text-white border-gray-900" : "bg-white hover:bg-gray-50"}`}>
                        {m.l}
                    </button>
                ))}
            </div>
            {rows.length === 0 ? (
                <div className="text-sm text-muted-foreground py-10 text-center" data-testid="activity-empty">No activity in this range.</div>
            ) : (
                <div className="h-64" data-testid="activity-chart">
                    <ResponsiveContainer width="100%" height="100%" initialDimension={{ width: 800, height: 256 }}>
                        <BarChart data={rows}>
                            <CartesianGrid strokeDasharray="3 3" vertical={false} />
                            <XAxis dataKey="date" tick={{ fontSize: 11 }} />
                            <YAxis allowDecimals={false} tick={{ fontSize: 11 }} />
                            <Tooltip />
                            <Legend wrapperStyle={{ fontSize: 12 }} />
                            {mode === "prevented" ? (
                                <Bar dataKey="prevented" name="Prevented sends" fill="#059669" />
                            ) : (
                                <>
                                    <Bar dataKey="dnc" stackId="a" name="Marketing DNC" fill="#e11d48" />
                                    <Bar dataKey="technical" stackId="a" name="Technical" fill="#d97706" />
                                    <Bar dataKey="review" stackId="a" name="Manual review" fill="#94a3b8" />
                                </>
                            )}
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            )}
        </SectionCard>
    );
}
